import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AssociativaLegaliForm } from 'src/app/common/form/associativa-legali-form';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { SezioneLegaliResponse } from '../../../models/dto/sezione-legali-response';
import { LegaleIncaricato } from '../../../models/legale-incaricato';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';

@Component({
    selector: 'div [associativa-legali-form-update]',
  templateUrl: '../../../form/associativa-legali-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class LegaliAssociativaUpdateComponent extends AssociativaLegaliForm implements OnInit {
  @Output() onReturn: EventEmitter<SezioneLegali> = new EventEmitter<SezioneLegali> ();

  sezione: SezioneLegali;
  legaleIncaricato: LegaleIncaricato;
  urlUpdate: string;

  constructor(@Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService) {
      super(operationService, campiForm, helpers);
  }

  inizializza(urlUpdate: string, legaleIncaricato: LegaleIncaricato, sezione: SezioneLegali, type: string) {
    this.legaleIncaricato = legaleIncaricato;
    this.sezione = sezione;
    this.type = type;
    this.populateSelect();
    this.createForm();
    this.urlUpdate = urlUpdate;
  }

  ngOnInit() {
    this.setTitle('Modifica Legale - Associativa');
    this.isInserimento(false);
  }

  getLegaleIncaricato() {
    return this.legaleIncaricato;
  }

  datiAssociativaLegaleIncaricato(response: SezioneLegaliResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  getRequest(request: LegaleIncaricato) {
    this.operationService.setLegaleIncaricatoInSezLegale(request, this.urlUpdate, this.sezione.id).subscribe(
      response => this.datiAssociativaLegaleIncaricato(response));
  }

  canCheckPrimary(): boolean {
    return this.inserimento;
  }
}
